type BuildQueryStringValue = string | number | boolean | undefined | null;
type BuildQueryStringProps = Record<
  string,
  BuildQueryStringValue | BuildQueryStringValue[] | undefined
>;

export const buildQueryString = (props: BuildQueryStringProps): string => {
  const query = new URLSearchParams();

  Object.entries(props).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => query.append(key, String(item)));
      return;
    }

    query.append(key, value.toString());
  });

  return query.toString();
};
